import { render, staticRenderFns } from "./productSetSelector.vue?vue&type=template&id=584e68cc&scoped=true&"
import script from "./productSetSelector.vue?vue&type=script&lang=js&"
export * from "./productSetSelector.vue?vue&type=script&lang=js&"
import style0 from "./productSetSelector.vue?vue&type=style&index=0&lang=css&"
import style1 from "./productSetSelector.vue?vue&type=style&index=1&id=584e68cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584e68cc",
  null
  
)

export default component.exports